<template>
  <article class="origin-information">
    <main>
      <div class="content" v-html="configStore.config.OriginInformation"></div>
    </main>
    <footer>
      <div class="mobile-menu__button">
        <BaseButton @button-click="handleConfirmClick">
          <template #icon>
            <img src="@/assets/images/icon-check-white.svg" alt="확인" />
          </template>
          {{ t('button.confirm') }}
        </BaseButton>
      </div>
    </footer>
  </article>
</template>

<script lang="ts" setup>
  import BaseButton from '@/components/base/BaseButton.vue';
  import { useConfigStore } from '@/stores/config';
  import { useModalStore } from '@/stores/modal';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const configStore = useConfigStore();
  const modalStore = useModalStore();

  const handleConfirmClick = () => modalStore.closeFullScreenModal();
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .origin-information {
    display: grid;
    grid-template-rows: 1fr auto;
    gap: 0.7813vw;
    height: 100%;
    padding: 2.9851vw;

    main {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      .content {
        width: 100%;
        height: 100%;
        ::v-deep(img) {
          max-width: 100%;
        }
      }
    }

    footer {
      display: flex;
      justify-content: center;
      .mobile-menu__button {
        width: 31.8657vw;
        @media (max-width: vars.$sm) {
          width: 100%;
        }
      }
    }
  }
</style>
